import {
  ExternalRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

export enum ExternalRoutesIds {
  adminClients = 'adminClients',
  flags = 'flags',
  metrics = 'metrics',
  metricsDataWarehouse = 'metricsDataWarehouse',
  flagAppliedConnections = 'flagAppliedConnections',
  assignmentTables = 'assignmentTables',
  factTables = 'factTables',
  chats = 'chats',
  insights = 'insights',
  recordings = 'recordings',
  recordingsGetStarted = 'recordingsGetStarted',
  experiments = 'experiments',
}

type ManuallyResolvedRouteIds =
  | 'workflow'
  | 'chat'
  | 'adminGithub'
  | 'adminNotion'
  | 'adminSlack'
  | 'adminGoogleDocs';

// Route ref with params — not included in ExternalRoutesIds since mapTaskHrefs
// only handles parameterless routes. Resolved manually in useOnboardingTasks.
export const workflowRouteRef = createExternalRouteRef({
  id: 'workflow',
  params: ['workflow'],
  optional: true,
});

export const chatRouteRef = createExternalRouteRef({
  id: 'chat',
  params: ['id'],
  optional: true,
});

// External route refs
export const adminClientsRouteRef = createExternalRouteRef({
  id: 'admin-clients',
  optional: true,
});

export const flagsRouteRef = createExternalRouteRef({
  id: 'flags',
  optional: true,
});

export const metricsRouteRef = createExternalRouteRef({
  id: 'metrics',
  optional: true,
});

export const metricsDataWarehouseRouteRef = createExternalRouteRef({
  id: 'metrics-data-warehouse',
  optional: true,
});

export const flagAppliedConnectionsRouteRef = createExternalRouteRef({
  id: 'flag-applied-connections',
  optional: true,
});

export const assignmentTablesRouteRef = createExternalRouteRef({
  id: 'assignment-tables',
  optional: true,
});

export const factTablesRouteRef = createExternalRouteRef({
  id: 'fact-tables',
  optional: true,
});

export const chatsRouteRef = createExternalRouteRef({
  id: 'chats',
  optional: true,
});

export const insightsRouteRef = createExternalRouteRef({
  id: 'insights',
  optional: true,
});

export const recordingsRouteRef = createExternalRouteRef({
  id: 'recordings',
  optional: true,
});

export const recordingsGetStartedRouteRef = createExternalRouteRef({
  id: 'recordings-get-started',
  optional: true,
});

export const experimentsRouteRef = createExternalRouteRef({
  id: 'experiments',
  optional: true,
});

export const adminGithubRouteRef = createExternalRouteRef({
  id: 'admin-github',
  optional: true,
});

export const adminNotionRouteRef = createExternalRouteRef({
  id: 'admin-notion',
  optional: true,
});

export const adminSlackRouteRef = createExternalRouteRef({
  id: 'admin-slack',
  optional: true,
});

export const adminGoogleDocsRouteRef = createExternalRouteRef({
  id: 'admin-google-docs',
  optional: true,
});

// External routes for plugin configuration
export const ExternalRoutes = {
  adminClients: adminClientsRouteRef,
  flags: flagsRouteRef,
  metrics: metricsRouteRef,
  metricsDataWarehouse: metricsDataWarehouseRouteRef,
  flagAppliedConnections: flagAppliedConnectionsRouteRef,
  assignmentTables: assignmentTablesRouteRef,
  factTables: factTablesRouteRef,
  workflow: workflowRouteRef,
  chat: chatRouteRef,
  chats: chatsRouteRef,
  insights: insightsRouteRef,
  recordings: recordingsRouteRef,
  recordingsGetStarted: recordingsGetStartedRouteRef,
  experiments: experimentsRouteRef,
  adminGithub: adminGithubRouteRef,
  adminNotion: adminNotionRouteRef,
  adminSlack: adminSlackRouteRef,
  adminGoogleDocs: adminGoogleDocsRouteRef,
} satisfies Record<
  ExternalRoutesIds | ManuallyResolvedRouteIds,
  ExternalRouteRef
>;
